import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const threeYearsOldEquipment: BlogMetaData = {
  title: '3歳向けモンテッソーリ教具・知育玩具おすすめ13選｜発達段階別の選び方【保育士監修】',
  description:
    '3歳の発達に合ったモンテッソーリ教具・知育玩具を厳選紹介。言語の爆発期・手の巧緻性・論理思考の3分野で選ぶ基準と比較表、家庭で始める3ステップをモンテ歴20年以上の保育士が解説します。',
  thumbnailUrl: '/img/blog-3-years-old-equipment.webp',
  filePath: buildBlogFilePath('3-years-old-equipment'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
